import { ExpandLess as IconExpandLess, ExpandMore as IconExpandMore } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { generatePath } from "react-router";

import { GaiaSubtleLink } from "~/modules/app/components/GaiaSubtleLink";

import { VisitInfoCardFragment } from "./fragments.generated";

type Props = {
    visit: VisitInfoCardFragment;
    isCollapsed: boolean;
    onToggleCollapsed: () => void;
};

export function VisitInfoCardHeader({ visit, isCollapsed, onToggleCollapsed }: Props) {
    return (
        <Stack direction="row" alignItems="center" columnGap={2} justifyContent="space-between">
            <Stack>
                <Stack rowGap={1}>
                    <Typography variant="caption">
                        <GaiaSubtleLink
                            to={generatePath("/c/:clientSlug", { clientSlug: visit.plannerArea.project.client.slug })}
                        >
                            {visit.plannerArea.project.client.name}
                        </GaiaSubtleLink>{" "}
                        •{" "}
                        <GaiaSubtleLink
                            to={generatePath("/c/:clientSlug/p/:projectSlug", {
                                clientSlug: visit.plannerArea.project.client.slug,
                                projectSlug: visit.plannerArea.project.slug,
                            })}
                        >
                            {visit.plannerArea.project.name}
                        </GaiaSubtleLink>{" "}
                        •{" "}
                        <GaiaSubtleLink
                            to={generatePath("/c/:clientSlug/p/:projectSlug/map-editor/:layerId/:featureId", {
                                clientSlug: visit.plannerArea.project.client.slug,
                                projectSlug: visit.plannerArea.project.slug,
                                layerId: visit.plannerArea.mapEditorFeature.layerId,
                                featureId: visit.plannerArea.mapEditorFeature.id,
                            })}
                        >
                            {visit.plannerArea.name}
                        </GaiaSubtleLink>
                    </Typography>
                    <Typography variant="h6">{visit.protocol.name}</Typography>
                </Stack>
                <Typography variant="subtitle2">
                    {visit.protocolVisit.name ? visit.protocolVisit.name : visit.protocolVisit.number}
                </Typography>
            </Stack>
            <Box>
                <IconButton onClick={onToggleCollapsed}>{isCollapsed ? <IconExpandLess /> : <IconExpandMore />}</IconButton>
            </Box>
        </Stack>
    );
}
